export const warningText = 'Please make sure you entered your yearly income correctly';
export const title = 'What’s your total annual income, before taxes?';
export const header =
  'Understanding your total income from all sources helps us personalize the best loan offer for you.';
export const inputLabel = 'Total Annual Income';
export const minIncome = 10000;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pages/Income/Income.scss');